import {
  FilterType,
  FilterTypeSearch,
  FilterTypeToFilter,
} from '../../common/filters-utils/filters-utils';
import { setExclusinsExpiredWeek } from '../store-actions/exclusions-store-actions';
import { Exclusion } from '../types/exclusion-types';

export const snackBarSpplitingName = (input: string) => {
  if (input.length > window.innerWidth / 10) {
    return input.slice(0, window.innerWidth / 10) + '...';
  }
  return input;
};

export const exclusionsFilters = [
  {
    type: FilterTypeToFilter.appName,
    header: FilterType.appName,
    searchType: FilterTypeSearch.appName,
  },
  {
    type: FilterTypeToFilter.exclusionType,
    header: FilterType.exclusionType,
  },
  {
    type: FilterTypeToFilter.issueName,
    header: FilterType.issueNames,
    searchType: FilterTypeSearch.issueName,
  },
  {
    type: FilterTypeToFilter.modifiedBy,
    header: FilterType.modifiedBy,
  },
  {
    type: FilterTypeToFilter.policyName,
    header: FilterType.policyName,
  },
];

export const findExpiredSnoozeWeek = (exclusions: Exclusion[]) => {
  let checkExpired = false;
  let exclusinsExpired: Exclusion[] = [];
  exclusions.forEach(exclusion => {
    if (exclusion.inWeekExpired) {
      exclusinsExpired.push(exclusion);
      checkExpired = true;
    }
  });
  setExclusinsExpiredWeek(exclusinsExpired);
  return checkExpired;
};

export const findExpiredSnoozeDay = (exclusions: Exclusion[]) => {
  let checkExpired = false;
  let exclusinsExpired: Exclusion[] = [];

  exclusions.forEach(exclusion => {
    if (exclusion.inDayExpired) {
      exclusinsExpired.push(exclusion);
      checkExpired = true;
    }
  });
  return checkExpired;
};
